import React, { useEffect, useState } from 'react';
import './index.less';

export const Suspension = () => {

  const [flag, setFlag] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', e => {
      if (document.documentElement.scrollTop >= 300) {
        setFlag(true)
      } else {
        setFlag(false)
      }
    })

    return () => {
      window.removeEventListener('scroll', () => { })
    }
  }, [])

  const goTop = () => {
    window.scrollTo(0, 0)
  }

  return <div className='Suspension'>
    {
      flag ? <a className='back' onClick={goTop}><img src="https://img.dsers.com/images/icon-back.svg" /></a> : null
    }
    <a className='email' href="mailto:support@dserspro.com"><img src="https://img.dsers.com/images/icon-email.png" /></a>
    <a className='messenger' href="https://www.messenger.com/t/DSersOfficial"><img src="https://img.dsers.com/images/icon-messager.svg" /></a>
  </div>
}

